import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPanoramaView: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="panorama-view"><path d="M1.98878 4.03903C1.75995 3.96218 1.50813 4.00016 1.31215 4.14108C1.11618 4.282 1 4.50862 1 4.75001V19.25C1 19.492 1.11679 19.7192 1.31362 19.86C1.51045 20.0008 1.76314 20.038 1.9922 19.9598C8.86694 17.6141 15.1331 17.6141 22.0078 19.9598C22.2369 20.038 22.4895 20.0008 22.6864 19.86C22.8832 19.7192 23 19.492 23 19.25V4.75001C23 4.50862 22.8838 4.282 22.6878 4.14108C22.4919 4.00016 22.24 3.96218 22.0112 4.03903C15.0958 6.36152 8.90418 6.36152 1.98878 4.03903Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPanoramaView;
